
import Vue from 'vue';
import NotificationsHeader from './NotificationsHeader.vue';

export default Vue.extend({
  name: 'ClosedNotifications',

  components: {
    NotificationsHeader,
  },
  props: {
    notificationsNum: {
      type: Number,
      required: true,
      default: 0,
    },
    hasRedNotifications: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
});
